import { Group, Stack, Text, Title } from '@mantine/core';

export function PageHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap" mb="lg">
      <Stack gap={2}>
        <Title order={2} fz="xl">{title}</Title>
        {description && (
          <Text size="sm" c="dimmed" maw={620}>
            {description}
          </Text>
        )}
      </Stack>
      {action && <Group gap="xs">{action}</Group>}
    </Group>
  );
}
